/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class GotoSettingsModel {

        public workflowBlock: models.GotoWorkflowBlock;
        public potentialToBlocks: models.IWorkflowBlock[];
        public toBlock: models.IWorkflowBlock;

        constructor(workflowBlock: models.GotoWorkflowBlock, potentialToBlocks: models.IWorkflowBlock[]) {
            this.workflowBlock = workflowBlock;
            this.potentialToBlocks = potentialToBlocks;
            this.toBlock = workflowBlock.toBlock;
        }
    }
}